import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const LightenIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      htmlColor='transparent'

    >
      <path
        d="M10.6231 2.97663C10.6723 2.55747 10.1798 2.32913 9.92729 2.6533L3.42563 10.9975C3.21063 11.2725 3.39396 11.6908 3.72896 11.6908H9.55229C9.78979 11.6908 9.97396 11.9133 9.94396 12.1658L9.37729 17.0241C9.32729 17.4425 9.81896 17.6708 10.0723 17.3466L16.574 9.00247C16.789 8.72747 16.6056 8.30913 16.2706 8.30913H10.4473C10.2098 8.30913 10.0256 8.08663 10.0556 7.83413L10.6231 2.97663Z"
        stroke="#00598E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
